import { EventEmitter } from 'events';
import { AppDispatcher } from '..';
export class BaseStore extends EventEmitter {
    constructor() {
        super();
        this._dispatchToken = null;
    }
    subscribe(actionSubscribe) {
        this._dispatchToken = AppDispatcher.register(actionSubscribe());
    }
    getDispatchToken() {
        return this._dispatchToken;
    }
    emitChange() {
        this.emit('CHANGE');
    }
    addChangeListener(callback) {
        this.on('CHANGE', callback);
    }
    removeChangeListener(callback) {
        this.removeListener('CHANGE', callback);
    }
}
//# sourceMappingURL=BaseStore.js.map